import React, { useEffect, useRef } from 'react';
import useAPI from '../../../../hooks/useAPI';
import { filter } from 'rxjs';

export default Toggle;

const remoteControlDescription = {
  element_id: 'button_emoji',
  widget_type: 'button_emoji',
  element_type: 'button',
  clickable: true,
  override: true,
};

function Toggle(props) {
  const { onToggle } = props;

  const API = useAPI();
  /**
   *
   * @type {React.MutableRefObject<HTMLButtonElement>}
   */
  const ref = useRef();
  useEffect(() => {
    API.hostApp.createControl({
      element: remoteControlDescription,
      events: {
        click: onToggle,
      },
    });

    const eventSubscription = API.hostApp.message$
      .pipe(
        filter(
          ({ element_id }) =>
            element_id === remoteControlDescription.element_id,
        ),
      )
      .subscribe(onToggle);

    return () => {
      API.hostApp.removeControl({
        element: remoteControlDescription,
      });
      eventSubscription.unsubscribe();
    };
  }, [API.hostApp, onToggle]);

  useEffect(() => {
    /*
    ref.current.addEventListener('click', (_event) => {
      onToggle();
    });
*/
  }, [onToggle]);
  return (
    <button
      ref={ref}
      onClick={onToggle}
      hidden
      id={remoteControlDescription.element_id}
    >
      Toggle Emoji mode
    </button>
  );
}
